import { PhoneOutgoing, PhoneIncoming } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { AgentType } from './useVoiceClient'

interface Props {
  value: AgentType
  onChange: (v: AgentType) => void
  disabled?: boolean
}

export function AgentTypeSelector({ value, onChange, disabled }: Props) {
  const { t } = useTranslation('calls')
  const options: { type: AgentType; labelKey: string; icon: typeof PhoneOutgoing }[] = [
    { type: 'outbound', labelKey: 'voiceTest.agent.outbound', icon: PhoneOutgoing },
    { type: 'inbound', labelKey: 'voiceTest.agent.inbound', icon: PhoneIncoming },
  ]

  return (
    <div className="flex gap-2">
      {options.map(({ type, labelKey, icon: Icon }) => (
        <button
          key={type}
          onClick={() => onChange(type)}
          disabled={disabled}
          className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-all ${
            value === type
              ? 'bg-primary/20 text-primary ring-1 ring-primary/40'
              : 'bg-surface-elevated text-text-secondary hover:bg-surface-card hover:text-text-primary'
          } disabled:cursor-not-allowed disabled:opacity-50`}
        >
          <Icon className="h-4 w-4" />
          {t(labelKey)}
        </button>
      ))}
    </div>
  )
}
